import { render, staticRenderFns } from "./PanelParticipationChart.vue?vue&type=template&id=b3c337c0"
import script from "./PanelParticipationChart.vue?vue&type=script&lang=js"
export * from "./PanelParticipationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports